import { countries } from "country-flags-svg";


export async function getAddressFromGPS(gpsString) {
    try {
        const [lat, lng] = gpsString.split(',').map(coord => parseFloat(coord.trim()));
        if (isNaN(lat) || isNaN(lng)) return gpsString;

        // Google Maps Geocoding API (replace YOUR_API_KEY with your actual key)
        const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`
        );

        // if (!response.ok) throw new Error("Geocoding failed");
        if (!response.ok) return "Unknown"

        const data = await response.json();
        // Extract the most relevant address component (e.g., city, region)
        // const address = data.address;
        // const city = address.city || "";
        // const country = address.country || "";
        // return `${city}, ${country}`;
        return data.display_name;
    } catch (error) {
        console.error("Geocoding error:", error);
        return "Unknown";
    }
}


/**
 * Get country name and flag URL from alpha-2 code (e.g., "ID" → Indonesia)
 * @param {string} code - ISO 3166-1 alpha-2 code (e.g., "US", "ID")
 * @returns {Object} { name: string, flagUrl: string } or null if not found
 */
export function getCountryData(code) {
    try {
        if (!code) return {};

        const country = countries.find(c => c.iso2 === code.toUpperCase());
        if (!country) return {};
        console.log("country", country);
        return country
    } catch (error) {
        console.error("Error to Get Country Data:", "Code:", code, "Error:", error);
        return {};
    }
}
